import { render, staticRenderFns } from "./sendPushNotification.vue?vue&type=template&id=37586c3d&"
import script from "./sendPushNotification.vue?vue&type=script&lang=js&"
export * from "./sendPushNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports